import request from '@/utils/request'


export function do_withdraw(form) {
    return request({
        url: '/api/withdraw/do_withdraw',
        method: 'post',
        data: {
          money: form.money,
          wallet_address: form.walletAddress,
          pay_password: form.payPassword
        }
    })
}
export function getWithdrawList() {
    return request({
        url: '/api/withdraw/index',
        method: 'get'
    })
}
